<template>
  <div>{{ title }}</div>
</template>

<script>
export default {
  props: ["title"],
};
</script>
<style scoped>
div {
  color: white !important;
  margin: 30px 20px 0px 0;
  font-size: 18px;
}
</style>
